import { createApp } from 'vue';
import {Notify, Quasar} from 'quasar';
import App from './App.vue'

const app = createApp(App)
app.use(Quasar, {
	plugins: {
		Notify
	}
  });
const container = document.getElementById("eContainer");
app.mount(container)

function updateChartSize() {container.style.height = window.innerHeight + 'px';}
updateChartSize();
window.addEventListener('resize', updateChartSize);
